export class ErrorModel {
  constructor(public error: any, public message: string) { }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/models/error-model.ts